import { render, staticRenderFns } from "./Editar-Comunicado.vue?vue&type=template&id=3f6a5360&scoped=true&"
import script from "./Editar-Comunicado.vue?vue&type=script&lang=js&"
export * from "./Editar-Comunicado.vue?vue&type=script&lang=js&"
import style0 from "./Editar-Comunicado.vue?vue&type=style&index=0&id=3f6a5360&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6a5360",
  null
  
)

component.options.__file = "Editar-Comunicado.vue"
export default component.exports